import React, { FC, ReactNode } from 'react';
import { Skeleton } from '@mui/material';
import { isDarkTheme } from '../../utils';
import { WHITE } from '../../constants';

type SkeletonRowProps = {
  label: ReactNode;
  amount?: ReactNode;
  isLoading: boolean;
  style?: any;
};

const SkeletonRow: FC<SkeletonRowProps> = ({
  label,
  amount,
  isLoading,
  style = {},
}) => {
  return (
    <div
      className='row w-100'
      style={isLoading ? {} : style}
    >
      <div className='col-8'>
        {isLoading ? (
          <Skeleton
            variant='text'
            width={100}
            height={20}
            sx={{ bgcolor: isDarkTheme() ? WHITE : null }}
          />
        ) : (
          label
        )}
      </div>
      {amount && (
        <div
          className='col-4 row '
          style={{ justifyContent: 'right' }}
        >
          {isLoading ? (
            <Skeleton
              variant='text'
              width={80}
              height={20}
              sx={{ bgcolor: isDarkTheme() ? WHITE : null }}
            />
          ) : (
            amount
          )}
        </div>
      )}
    </div>
  );
};

export default SkeletonRow;
